import { render, staticRenderFns } from "./elementDataLayer.vue?vue&type=template&id=53bdfc39&scoped=true&"
import script from "./elementDataLayer.vue?vue&type=script&lang=js&"
export * from "./elementDataLayer.vue?vue&type=script&lang=js&"
import style1 from "./elementDataLayer.vue?vue&type=style&index=1&id=53bdfc39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdfc39",
  null
  
)

export default component.exports